import React from 'react'

export default (props) => {
	const {
		children,
	} = props

	return (
		<div className="slide">
			<div className="slide__spacing">
				{children}
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/mobile/components/slide/index.js